<template>
  <div>
    <dashboard-page-title :showFilter="false" :showSearch="false" :showExportation="false" :showAddBtn="false">اضافة اوراق جديدة</dashboard-page-title>
    <ValidationObserver ref="requiredDocForm" v-slot="{ handleSubmit, invalid }">
      <b-form class="position-relative form-top w-50" @submit.prevent="handleSubmit(onSubmit)">
        <input-form
          label="الاسم (العربية)"
          name="الاسم بالعربية"
          vid="required-doc-name-ar"
          id="required-doc-name-ar"
          placeholder="أدخل الاسم بالعربية"
          v-model="nameAr"
          validate="arabic_name"
        />
        <input-form
          label="الاسم (الإنجليزية)"
          name="الاسم بالإنجليزية"
          vid="required-doc-name-en"
          id="required-doc-name-en"
          placeholder="Enter name in English"
          v-model="nameEn"
          validate="english_name"
        />
        <b-form-group label-cols-md="12" label="نشط" label-for="required-doc-active-yes">
          <div class="d-flex align-items-center flex-wrap required-doc-active-row">
            <b-form-radio
              id="required-doc-active-yes"
              v-model="status"
              class="mb-2"
              name="required-doc-active"
              value="1"
            >
              نعم
            </b-form-radio>
            <b-form-radio
              id="required-doc-active-no"
              v-model="status"
              class="mb-2"
              name="required-doc-active"
              value="0"
            >
              لا
            </b-form-radio>
          </div>
        </b-form-group>
        <b-button variant="primary" :disabled="invalid || isSubmitting" type="submit">
          <span class="font-size-18 px-5">{{ isSubmitting ? 'جاري الإضافة...' : 'اضافة' }}</span>
        </b-button>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { core } from '@/config/pluginInit'
import transportationServices from '@/modules/transportation/services/transportation'

export default {
  name: 'addRequired',
  data () {
    return {
      nameAr: '',
      nameEn: '',
      status: '1',
      isSubmitting: false
    }
  },
  computed: {
    documentType () {
      const t = (this.$route.query && this.$route.query.type) || ''
      return String(t).toLowerCase() === 'driver' ? 'driver' : 'company'
    }
  },
  methods: {
    trimFields () {
      this.nameAr = (this.nameAr || '').trim()
      this.nameEn = (this.nameEn || '').trim()
    },
    buildTranslations () {
      return [
        { lang: 'ar', name: this.nameAr },
        { lang: 'en', name: this.nameEn }
      ]
    },
    async onSubmit () {
      this.trimFields()
      await this.$nextTick()
      const isValid = await this.$refs.requiredDocForm.validate()
      if (!isValid) {
        return
      }
      this.isSubmitting = true
      transportationServices.addRequiredDocument({
        type: this.documentType,
        status: String(this.status),
        translations: this.buildTranslations()
      }).then(res => {
        core.showSnackbar('success', res.data.message)
        this.nameAr = ''
        this.nameEn = ''
        this.status = '1'
        this.$refs.requiredDocForm.reset()
      }).catch(() => {
        core.showSnackbar('error', 'حدث خطأ أثناء الإضافة، يرجى المحاولة مرة أخرى')
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  },
  mounted () {
    core.index()
  }
}
</script>

<style scoped>
.required-doc-active-row {
  gap: 15px;
}
</style>
